export default "/images/9f6c642d9e2ebb45350b06b422d88a97.avif";